﻿import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import RadioButtonsStegContainer from '../Shared/Scripts/Components/RadioButtonsStegComponent';
import NumberInputStepStegContainer from './Components/NumberInputStepStegComponent';

import Valg from '../Shared/Scripts/Models/Valg';

import BFamiliesituasjon from './Utilities/B-Familiesituasjon';
import VeilederBarnestipendDto from './Models/VeilederBarnestipendDto';
import { VeilederBarnestipendAppState } from './Store';
import * as Ids from './Models/Ids';
import * as ValgTypes from './Store/Valg/Types';
import { updateValg, updateVisning } from './Store/Valg/Actions';
import C1ResultatComponent from './Components/C1ResultatComponent';
import C2ResultatComponent from './Components/C2ResultatComponent';
import { ResultatValg } from './Store/Resultat/Types';
import { registerAnalyticsEvent } from '../Shared/Scripts/Utilities/Analytics';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AppOwnProps {}

type AppProps = AppOwnProps & MapStateToProps & MapDispatchToProps;

const RadioButtonsStegComponent = RadioButtonsStegContainer<VeilederBarnestipendDto>();
const NumberInputStepStegComponent = NumberInputStepStegContainer();

const container = document.getElementById(Ids.AppContainerId)!;
ReactModal.setAppElement(container);

const analyticsState = { startet: false, fullfort: false };
const eventId = container.parentElement!.getAttribute('data-eventid');

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render(): JSX.Element {
        const { valg, resultat, dispatchUpdateValg, epiContext } = this.props;
        const { epiModel } = this.props.epiContext;

        if (epiContext.epiModelFeilet || resultat.visGenerellFeil) {
            return <FeilmeldingComponent />;
        }

        function registerEvents(): void {
            if (!analyticsState.startet) {
                if (valg.antallBarn != 1 || valg.bFamiliesituasjon != undefined) {
                    analyticsState.startet = true;
                    registerAnalyticsEvent({ action: 'VeilederStart', eventId }); 
                }
            }

            if (!analyticsState.fullfort) {
                if (resultat.visResultatC1 || resultat.visResultatC2) {
                    analyticsState.fullfort = true;
                    registerAnalyticsEvent({ action: 'VeilederFerdig', eventId }); 
                }
            }
        }

        if (epiModel != null) {
            return (
                <div className="c-veileder">
                    {registerEvents()}
                    <NumberInputStepStegComponent
                        sporsmalId={Ids.BoksA}
                        tittel={contentResolver(epiContext, 'antallBarnTittel')}
                        forklaring={contentResolver(epiContext, 'antallBarnBrodtekst')}
                        value={valg.antallBarn}
                        onInputChange={(nyttValg: number): void => {
                            dispatchUpdateValg({ antallBarn: nyttValg });
                        }}
                        classModifier="c-veileder__panel--input-white"
                        inputId="a-antall-barn"
                    />
                    <RadioButtonsStegComponent
                        sporsmalId={Ids.BoksB}
                        classModifier="c-veileder__panel--cotton-candy"
                        tittel={contentResolver(epiContext, 'familiesituasjonTittel')}
                        forklaring={contentResolver(epiContext, 'familiesituasjonBrodtekst')}
                        sporsmal="familiesituasjonnLedetekstSporsmal"
                        valg={BFamiliesituasjon.bValg}
                        onInputChange={(nyttValg: Valg<string>): void => {
                            dispatchUpdateValg({ bFamiliesituasjon: nyttValg });
                        }}
                        value={valg.bFamiliesituasjon}
                        neverCollapse={true}
                    />
                    {resultat.visResultatC1 && <C1ResultatComponent eventId={eventId} />}
                    {resultat.visResultatC2 && <C2ResultatComponent eventId={eventId} />}
                </div>
            );
        } else {
            return <div>Laster...</div>;
        }
    }
}

interface MapStateToProps {
    valg: ValgTypes.ValgState;
    epiContext: EpiContext<VeilederBarnestipendDto>;
    resultat: ResultatValg;
}

interface MapDispatchToProps {
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>) => void;
}

const mapDispatchToProps = (
    dispatch: ThunkDispatch<VeilederBarnestipendAppState, {}, AnyAction>,
): MapDispatchToProps => ({
    dispatchUpdateValg: (newValg: Partial<ValgTypes.ValgState>): void => {
        dispatch(updateValg(newValg));
        dispatch(updateVisning());
    },
});

const mapStateToProps = (state: VeilederBarnestipendAppState): MapStateToProps => ({
    valg: state.valg,
    epiContext: state.epiContext,
    resultat: state.resultat,
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
